/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 */

import ButtonLink from 'components/ButtonLink';
import Container from 'components/Container';
import Flex from 'components/Flex';
import CodeExample from 'components/CodeExample';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { graphql } from 'gatsby';
import TitleAndMetaTags from 'components/TitleAndMetaTags';
import Layout from 'components/Layout';
import { colors, media, sharedStyles } from 'theme';
import loadScript from 'utils/loadScript';
import createCanonicalUrl from 'utils/createCanonicalUrl';
import { babelURL } from 'site-constants';
// import logoWhiteSvg from 'icons/logo-white.svg';
// https://www.npmjs.com/package/react-google-recaptcha (buon pacchetto per captcha, già installato, solo da implementare...)

import Visit from '../components/Apis/visit.js'
import Like from '../components/Apis/like.js'
import VisitHome from '../components/Apis/visit-home.js';

import Snowfall from 'react-snowfall';
import Typed from 'react-typed';
import 'react-typed/dist/animatedCursor.css';
import Confetti from 'react-confetti';
import MatrixBackground from '../components/matrix.jsx';
import CypherText from 'react-cypher-text-loop';
import { TypeAnimation } from 'react-type-animation';
import { FallingEmojis } from 'falling-emojis';
// import AnimatedText from 'react-animated-text-content';

// import logo_react from '../images/logo_react.svg'

import bellAudio from '../images/beep.mp3';
import ReactPlayer from 'react-player';
import ReactAudioPlayer from 'react-audio-player';

class Home extends Component {
  state = {
    babelLoaded: false,
    logoreact: null,
  };



  componentDidMount() {
    loadScript(babelURL).then(
      () => {
        this.setState({
          babelLoaded: true,
        });
      },
      error => {
        console.error('Babel failed to load.');
      },
    );
  }


  render() {
    const { babelLoaded } = this.state;
    const { data, location } = this.props;
    const { codeExamples, examples, marketing } = data;

    const code = codeExamples.edges.reduce((lookup, { node }) => {
      lookup[node.mdAbsolutePath] = node;
      return lookup;
    }, {});



    // const snowflake1 = document.createElement('img') ("'document.' non funziona con gatsby in fase di deploy")
    // const snowflake1 = this.state.logo_react
    // const snowflake2 = document.createElement('img')
    // snowflake2.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Golden_star.svg/2140px-Golden_star.svg.png'

    // const images = [snowflake1, snowflake2]

    this.state.titoloSito = 'Milani';
    // this.state.logoreact = logo_react;

    return (
      <Layout location={location}>
        <MatrixBackground />
        <FallingEmojis emoji={'ﷲ'} />
        <Snowfall
          snowflakeCount={14}
          // style={{
          //   position: 'fixed',
          //   width: '100vw',
          //   height: '100vh',
          // }}
          speed={[3.0, 1.0]}
          wind={[-0.5, 5.0]}
          rotationSpeed={[-1.0, 1.0]}
          radius={[1, 5]}
          changeFrequency={200}
          color={['gold']}
        // images={[this.state.logoreact]}

        // https://github.com/cahilfoley/react-snowfall (togliendo gli attributi e lasciando solo il tag, piovono solo fiocchi bianchi di neve)

        />
        <TitleAndMetaTags
          title="Milani &ndash; Il blog e sito ufficiale di Mostafa Milani Amin"
          canonicalUrl={createCanonicalUrl('/')}
        />
        <div
          css={{
            width: '100%',
          }}>
          <header
            css={{
              backgroundColor: colors.dark,
              color: colors.white,
            }}>

            <VisitHome />
            <div
              css={{
                paddingTop: 45,
                paddingBottom: 10,

                [media.greaterThan('small')]: {
                  paddingTop: 60,
                  paddingBottom: 70,
                },

                [media.greaterThan('xlarge')]: {
                  paddingTop: 95,
                  paddingBottom: 85,
                  maxWidth: 1500, // Positioning of background logo
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  position: 'relative',
                  '::before': {
                    content: ' ',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    // backgroundImage: `url(${logoWhiteSvg})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '100% 100px',
                    backgroundSize: '50% auto',
                    opacity: 0.05,
                  },
                },
              }}>
              <Confetti
                numberOfPieces={1}

                drawShape={ctx => {
                  ctx.beginPath()
                  for (let i = 0; i < 22; i++) {
                    const angle = 0.35 * i
                    const x = (0.2 + (1.5 * angle)) * Math.cos(angle)
                    const y = (0.2 + (1.5 * angle)) * Math.sin(angle)
                    ctx.lineTo(x, y)
                  }
                  ctx.stroke()
                  ctx.closePath()
                }}

              // https://www.npmjs.com/package/react-confetti
              />
              <div
                css={{
                  // Content should be above absolutely-positioned hero image
                  position: 'relative',
                }}>
                <Container>


                  {/* <div style={{color: '#30d5c8', margin: '-18.5px', fontWeight: 'bold'}}><Visit /></div><br /><br />
                  <div style={{color: '#30d5c8', margin: '-18.5px', fontWeight: 'bold'}}><Like /></div> */}
                  <h1 className="brand"
                    css={{
                      color: colors.brand,
                      textAlign: 'center',
                      margin: -20.5,
                      fontSize: 45,
                      letterSpacing: '0.01em',
                      [media.size('xsmall')]: {
                        fontSize: 30,
                      },
                      [media.greaterThan('xlarge')]: {
                        fontSize: 60,
                      },
                    }}>

                    <CypherText
                      textList={['Mostafa', 'Milani', 'Amin']}
                      delay="800"
                      placeholders="____-_\/[]{}—=+*^?#!<>"
                    />
                    {/* https://github.com/CarterMcAlister/react-cypher-text-loop#readme */}

                    {/* <Typed
                      strings={['Milani']}
                      typeSpeed={10}
                      showCursor={false}
                    // React typing animation effect: https://dev.to/techfortified/react-typing-animation-effect-4gk --- https://mattboldt.github.io/typed.js/docs/ --- http://ssbeefeater.github.io/react-typed/?knob-shuffle=false&knob-cursorChar=%7C&knob-backDelay=1&knob-fadeOutDelay=100&knob-backspeed=20&knob-showCursor=true&knob-Strings%5B0%5D=welcome%20to%20react-typed&knob-Strings%5B1%5D=This%20is%20a%20react%20component%20that%20wraps%20up%20the%20%3Ca%20href%3D%22https%3A%2F%2Fgithub.com%2Fmattboldt%2Ftyped.js%2F%22%3Etyped.js%3C%2Fa%3E&knob-Strings%5B2%5D=If%20you%20like%20the%20project%20add%20a%20star%20in%20%3Ca%20href%3D%22https%3A%2F%2Fgithub.com%2Fmattboldt%2Ftyped.js%2F%22%3Etyped.js%3C%2Fa%3E%20and%20%3Ca%20href%3D%22https%3A%2F%2Fgithub.com%2Fmattboldt%2Ftyped.js%2F%22%3Ereact-typed%3C%2Fa%3E&knob-smartBackspace=true&knob-loopCount=0&knob-type%20speed=50&knob-fadeOut=false&knob-loop=true&selectedKind=react-typed&selectedStory=Basic%20Example&full=0&down=1&left=1&panelRight=0&downPanel=storybooks%2Fstorybook-addon-knobs
                    /> */}

                    {/* Milani */}

                  </h1>
                  <p
                    css={{
                      paddingTop: 35.5,
                      textAlign: 'center',
                      fontSize: 24,
                      letterSpacing: '0.01em',
                      fontWeight: 200,

                      [media.size('xsmall')]: {
                        fontSize: 16,
                        maxWidth: '12em',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      },

                      [media.greaterThan('xlarge')]: {
                        paddingTop: 40.5,
                        fontSize: 30,
                      },
                    }}>

                    <Typed
                      style={{ fontSize: '21px' }}
                      strings={['Il blog e sito ufficiale di']}
                      typeSpeed={50}
                      showCursor={false}
                    // React typing animation effect: https://dev.to/techfortified/react-typing-animation-effect-4gk --- https://mattboldt.github.io/typed.js/docs/
                    />
                    <br />
                    {/* <AnimatedText
                      type="chars" // animate words or chars
                      animation={{
                        x: '200px',
                        y: '-20px',
                        scale: 1.1,
                        ease: 'ease-in-out',
                      }}
                      // animationType="float"
                      animationType="bounce"
                      interval={0.06}
                      duration={0.8}
                      tag="p"
                      className="animated-paragraph"
                      includeWhiteSpaces
                      threshold={0.1}
                      rootMargin="20%"
                      style={{color:'gold', fontWeight: 'bold'}}
                    >
                      Mostafa Milani Amin
                    </AnimatedText> */}
                    {/* https://www.npmjs.com/package/react-animated-text-content */}

                    {/* Il blog e sito ufficiale di Mostafa Milani Amin */}

                    {/* <Typed
                      style={{ color: 'gold', fontWeight: 'bold' }}
                      strings={['Mostafa Milani Amin']}
                      typeSpeed={110}
                      // backSpeed={100}
                      // loop
                      showCursor={false}
                    // React typing animation effect: https://dev.to/techfortified/react-typing-animation-effect-4gk --- https://mattboldt.github.io/typed.js/docs/
                    /> */}


                    <TypeAnimation
                      sequence={[
                        1000,
                        'Mostafa Milani Amin',
                        () => {
                          '';
                        },
                        1000,
                        () => {
                          '';
                        },
                        '',
                        () => {
                          '';
                        },
                        'Mostafa Milani Amin',

                        // () => {
                        //   console.log('Done typing!'); // Place optional callbacks anywhere in the array
                        // }
                      ]}
                      wrapper="span"
                      cursor={false}
                      repeat={1}
                      speed={50}
                      // deletionSpeed={99}
                      omitDeletionAnimation={false}
                      // style={{ fontSize: '2em' }}
                      style={{ color: 'gold', fontWeight: 'bold' }}

                    // https://www.npmjs.com/package/react-type-animation

                    />

                    {/* <TypeAnimation
sequence={[
      1500,
      () => {
        'Typing...';
      },
      'Mostafa Milani Amin',
      () => {
       'Done Typing';
      },
      1000,
      () => {
        'Deleting...';
      },
      '',
      () => {
        'Done Deleting';
      },
     ]}
    speed={70}
    wrapper="div"
    repeat={Infinity}
  /> */}


                  </p>
                  <Flex
                    valign="center"
                    halign="center"
                    css={{
                      paddingTop: 40,
                      flexWrap: 'wrap',
                      justifyContent: 'center',

                      [media.greaterThan('xlarge')]: {
                        paddingTop: 65,
                      },
                    }}>
                    <CtaItem>
                      <ButtonLink
                        to="/libri/compendio-dottrina-islamica.html"
                        type="primary">
                        Inizia qui
                      </ButtonLink>
                    </CtaItem>
                    <CtaItem>
                      <ButtonLink to="/biografia/biografia.html" type="secondary">
                        Leggi la biografia
                      </ButtonLink>
                    </CtaItem>
                  </Flex>
                </Container>
              </div>
            </div>
          </header>

          <Container>
            <div css={sharedStyles.markdown}>
              <section
                css={[
                  sectionStyles,
                  {
                    [media.lessThan('medium')]: {
                      marginTop: 0,
                      marginBottom: 0,
                      overflowX: 'auto',
                      paddingTop: 30,
                      WebkitOverflowScrolling: 'touch',
                      position: 'relative',
                      maskImage:
                        'linear-gradient(to right, transparent, white 10px, white 90%, transparent)',
                    },
                  },
                ]}>
                <div
                  css={{
                    display: 'flex',
                    flexDirection: 'row',

                    [media.lessThan('medium')]: {
                      display: 'block',
                      whiteSpace: 'nowrap',
                    },
                  }}>
                  {marketing.edges.map(({ node: column }, index) => (
                    <div
                      key={index}
                      css={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '0 1 33%',
                        marginLeft: 40,

                        '&:first-of-type': {
                          marginLeft: 0,

                          [media.lessThan('medium')]: {
                            marginLeft: 10,
                          },
                        },

                        [media.lessThan('medium')]: {
                          display: 'inline-block',
                          verticalAlign: 'top',
                          marginLeft: 0,
                          whiteSpace: 'normal',
                          width: '75%',
                          marginRight: 20,
                          paddingBottom: 40,

                          '&:first-of-type': {
                            marginTop: 0,
                          },
                        },
                      }}>
                      <h3
                        css={[
                          headingStyles,
                          {
                            '&&': {
                              // Make specificity higher than the site-wide h3 styles.
                              color: colors.subtle,
                              paddingTop: 0,
                              fontWeight: 300,
                              fontSize: 20,

                              [media.greaterThan('xlarge')]: {
                                fontSize: 24,
                              },
                            },
                          },
                        ]}>
                        {column.frontmatter.title}
                      </h3>
                      <div dangerouslySetInnerHTML={{ __html: column.html }} />
                    </div>
                  ))}
                </div>
              </section>
              <br /> <br />
              {/* Sezione examples disattivata */}
              {/* <hr
                css={{
                  height: 1,
                  marginBottom: -1,
                  border: 'none',
                  borderBottom: `1 solid ${colors.divider}`,
                }}
              />
              <section css={sectionStyles}>
                <div id="examples">
                  {examples.edges.map(({ node }, index) => {
                    const snippet = code[node.fileAbsolutePath];
                    return (
                      <CodeExample
                        key={index}
                        id={snippet.id}
                        code={snippet.code}
                        containerNodeID={node.frontmatter.domid}
                        loaded={babelLoaded}>
                        <h3 css={headingStyles}>{node.frontmatter.title}</h3>
                        <div dangerouslySetInnerHTML={{ __html: node.html }} />
                      </CodeExample>
                    );
                  })}
                </div>
              </section> */}

            </div>
          </Container>

          <section
            css={{
              background: colors.dark,
              color: colors.white,
              paddingTop: 45,
              paddingBottom: 25,
            }}>
            <Container>
              <Flex
                valign="center"
                halign="center"
                css={{
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                }}>
                <CtaItem>
                  <ButtonLink to="/libri/compendio-dottrina-islamica.html" type="primary">
                    Inizia qui
                  </ButtonLink>
                </CtaItem>
                <CtaItem>
                  <ButtonLink to="/biografia/biografia.html" type="secondary">
                    Leggi la biografia
                  </ButtonLink>
                </CtaItem>
              </Flex>
            </Container>
          </section>
        </div>

        {/* <ReactPlayer src={[bellAudio]} autoplay
                // autoplay style={{ display: 'none' }}
        /> */}

<ReactAudioPlayer
  src={bellAudio}
  autoPlay="true"
  // controls
/>

      </Layout>
    );
  }
}

Home.propTypes = {
  data: PropTypes.shape({
    examples: PropTypes.object.isRequired,
    marketing: PropTypes.object.isRequired,
  }).isRequired,
};

const CtaItem = ({ children, primary = false }) => (
  <div
    css={{
      [media.between('small', 'large')]: {
        paddingLeft: 20,
      },

      [media.greaterThan('xlarge')]: {
        paddingLeft: 40,
      },

      '&:first-child': {
        textAlign: 'right',
        paddingRight: 7,
        paddingLeft: 7,
        [media.lessThan('small')]: {
          marginBottom: 10,
        },
      },

      '&:nth-child(2)': {
        paddingRight: 7,
        paddingLeft: 7,
        [media.greaterThan('small')]: {
          paddingLeft: 15,
        },
        [media.lessThan('small')]: {
          marginBottom: 10,
        },
      },
    }}>
    {children}
  </div>
);

export const pageQuery = graphql`
  query IndexMarkdown {
    codeExamples: allExampleCode {
      edges {
        node {
          id
          code
          mdAbsolutePath
        }
      }
    }

    examples: allMarkdownRemark(
      filter: {fileAbsolutePath: {regex: "//home/examples//"}}
      sort: {fields: [frontmatter___order], order: ASC}
    ) {
      edges {
        node {
          fileAbsolutePath
          fields {
            slug
          }
          frontmatter {
            title
            domid
          }
          html
        }
      }
    }
    marketing: allMarkdownRemark(
      filter: {fileAbsolutePath: {regex: "//home/marketing//"}}
      sort: {fields: [frontmatter___order], order: ASC}
    ) {
      edges {
        node {
          frontmatter {
            title
          }
          html
        }
      }
    }
  }
`;

export default Home;

const sectionStyles = {
  marginTop: 20,
  marginBottom: 15,

  [media.greaterThan('medium')]: {
    marginTop: 60,
    marginBottom: 65,
  },
};

const headingStyles = {
  '&&': {
    marginBottom: 20,
  },
};
